import React from 'react';
import Axios from "axios";

export const base_url = 'https://amhara.in/zeo/api/auth/';
export const image_url = 'https://amhara.in/zeo/public/';
export const LoginURL = 'login';
export const ProductsURL = 'user/shop';
export const IngredientPrr = 'user/ingredient-products';
export const ProductDetailURL = 'user/product_detail';
export const RegisterURL = 'register';
export const VerifyOtpURL = 'verify-otp';
export const forgotPassword = 'forgot-password';
export const loginWithOtp = 'loginWithOtp';
export const homeURL = 'user/home';
export const AddToCartURL = 'user/add-cart';
export const CartListURL = 'user/cart-list';
export const RemoveCart = 'user/remove-cart';
export const ApplyCouponUrl = 'user/apply-coupon';
export const CouponListUrl = 'user/coupon-list';
export const CountryUrl = 'user/country';
export const StateUrl = 'user/state';
export const CityUrl = 'user/city';
export const AddAddressUrl = 'user/add-address';
export const ListAddressUrl = 'user/list-address';
export const RemoveAddrUrl = 'user/remove-address';
export const savebookingUrl = 'user/save-booking';
export const orderListUrl = 'user/order-list';
export const updatePasswordUrl = 'user/change-password';
export const FilterList = 'user/filter-list';
export const cancelOrder = 'user/order-cancel';


export const Post = ({body,url}) => {
    return new Promise((resolve,reject)=>{
        const config = {
            method: 'post',
            url: `${base_url}${url}`,
            headers: { 
            'Content-Type': 'application/json',
            'Authorization':'Bearer '+global?.userInfo?.token
            },
            data : body
        };

        Axios(config).then((res)=>{
            if(res.status==200) {
                return resolve(res.data);
            }
        }).catch((err)=>{
            reject(err);
        })
    });
}


export const GET = ({url}) => {
    return new Promise((resolve,reject)=>{
        const config = {
            method: 'get',
            url: `${base_url}${url}`,
            headers: { 
              'Content-Type': 'application/json'
            },
        };
    
        Axios(config).then((res)=>{
            if(res.status==200) {
                return resolve(res.data);
            }
        }).catch((err)=>{
            reject(err);
        })
    })
    
}